export {
  SelectSchoolComponent,
  SelectSchoolResult,
} from './lib/select-school/select-school.component';
export { ForgotPasswordComponent } from './lib/forgot-password/forgot-password.component';
export {
  ChangePasswordComponent,
} from './lib/change-password/change-password.component';
export {
  SupportLoginComponent,
  SupportLoginResult,
} from './lib/support-login/support-login.component';
export { PasswordChangeResult } from './lib/password-dialog/password-dialog.validation';
export { LoginComponent } from './lib/login-form/login.component';
export { FORMULARIO_ROUTES } from './lib/formulario-routes';
export { TokenServiceTsService } from './lib/token/token.service';
